module.exports = __webpack_public_path__ + "static/media/recorded-content.e653bb82.png";